import { useEffect, useState } from "react";
import api from "@/lib/api";

let cachedNumber = null;

export default function WhatsAppLink({ label, testid = "whatsapp-link", className = "", message = "" }) {
  const [number, setNumber] = useState(cachedNumber);

  useEffect(() => {
    if (!cachedNumber) {
      api.get("/config")
        .then((r) => {
          cachedNumber = r.data.whatsapp_number || "393514545412";
          setNumber(cachedNumber);
        })
        .catch(() => setNumber("393514545412"));
    }
  }, []);

  const num = number || "393514545412";
  const href = `https://wa.me/${num}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid={testid}
      className={`inline-flex items-center gap-2 hover:text-navy transition-colors ${className}`}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true">
        <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.1 13.9c-.2.6-1.2 1.1-1.7 1.2-.4 0-.9.2-3.1-.6-2.6-1.1-4.3-3.8-4.4-4-.1-.2-1-1.4-1-2.7 0-1.3.7-1.9.9-2.2.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5s.7 1.8.8 1.9c.1.1.1.3 0 .5-.3.6-.6.8-.4 1.1.6 1 1.3 1.8 2.3 2.4.3.2.5.1.7-.1l.7-.8c.2-.2.4-.2.6-.1l1.8.9c.2.1.4.2.4.3 0 .1 0 .6-.3 1z"/>
      </svg>
      {label ?? `+${num}`}
    </a>
  );
}
